document.addEventListener("DOMContentLoaded", function () {
  //------------------  faq page tab js start -----------------//

  const tab_heading = document.querySelectorAll(".tab-heading-link");

  tab_heading.forEach(function (tab) {
    tab.addEventListener("click", function (event) {
      event.preventDefault();

      const dataTab = this.getAttribute("data-tab").trim();

      tab_heading.forEach(function (link) {
        link.classList.remove("active");
      });

      this.classList.add("active");

      const tabContent = document.querySelectorAll(".tab-content-description");
      tabContent.forEach(function (content) {
        const dataContent = content.getAttribute("data-content").trim();
        if (dataContent === dataTab) {
          content.classList.add("active");
          content.style.display = "block";
        } else {
          content.classList.remove("active");
          content.style.display = "none";
        }
      });

      const nextHidden = this.nextElementSibling;
      if (nextHidden && nextHidden.classList.contains("tab-hidden")) {
        const hiddenH2 = nextHidden.querySelector("h2");
        const bannerH2 = document.querySelector(".image-banner__text h2");
        if (hiddenH2 && bannerH2) {
          bannerH2.innerHTML = hiddenH2.innerHTML;
        }
      }

      const tabProduct = this.nextElementSibling?.nextElementSibling;
      if (tabProduct && tabProduct.classList.contains("tab-product")) {
        const url = tabProduct.getAttribute("data-url");

        const btn = document.querySelector(".image-banner__link");
        const btnUrl = btn.getAttribute("data-btn");

        if (url && btn) {
          btn.setAttribute("href", url);
        }
      }
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const tabName = urlParams.get("tab");

  if (tabName) {
    const tabButton = document.querySelector(`[data-tab="${tabName}"]`);

    const tabContent = document.querySelector(`[data-content="${tabName}"]`);

    if (tabButton && tabContent) {
      document
        .querySelectorAll(".tab-heading-link")
        .forEach((btn) => btn.classList.remove("active"));
      document
        .querySelectorAll(".tab-content-description")
        .forEach((content) => content.classList.remove("active"));

      tabButton.classList.add("active");
      tabContent.style.display = "block";
      tabContent.classList.add("active");
    }
  } else {
    if (tab_heading.length > 0) {
      const firstTab = tab_heading[0];
      const dataTab = firstTab.getAttribute("data-tab").trim();

      firstTab.classList.add("active");

      const tabContent = document.querySelectorAll(".tab-content-description");
      tabContent.forEach(function (content) {
        const dataContent = content.getAttribute("data-content").trim();
        if (dataContent === dataTab) {
          content.classList.add("active");
          content.style.display = "block";
        } else {
          content.classList.remove("active");
          content.style.display = "none";
        }
      });

      const nextHidden = firstTab.nextElementSibling;
      if (nextHidden && nextHidden.classList.contains("tab-hidden")) {
        const hiddenH2 = nextHidden.querySelector("h2");
        const bannerH2 = document.querySelector(".image-banner__text h2");
        if (hiddenH2 && bannerH2) {
          bannerH2.innerHTML = hiddenH2.innerHTML;
        }
      }

      const tabProduct = firstTab.nextElementSibling?.nextElementSibling;
      if (tabProduct && tabProduct.classList.contains("tab-product")) {
        const url = tabProduct.getAttribute("data-url");
        const btn = document.querySelector(".image-banner__link-wrap a");
        if (url && btn) {
          btn.setAttribute("href", url);
        }
      }
    }
  }

  //----------------------  faq page tab js end -----------------------------//

  //------------------- target block js start-----------------------------//
  let email_target = document.getElementById('email_target');
  if(email_target){
    email_target.addEventListener('click', function () {
      document.getElementById('gift-email-itg').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
  let Print_target = document.getElementById('Print_target');
  if(Print_target){
    Print_target.addEventListener('click', function () {
      document.getElementById('gift-print-itg').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
  //------------------- target block js end-----------------------------//

});